// Zuzu on social media: the footer, the after-chat popups, the chat-end card and the
// Press page's list of official accounts (with the handle).
export const SOCIAL_LINKS = [
  { key: 'instagram', name: 'Instagram', href: 'https://www.instagram.com/thezuzuclub/', handle: '@thezuzuclub' },
  { key: 'facebook', name: 'Facebook', href: 'https://www.facebook.com/zuzu.club.community', handle: 'zuzu.club.community' },
  { key: 'x', name: 'X', href: 'https://x.com/zuzu_club', handle: '@zuzu_club' },
  { key: 'linkedin', name: 'LinkedIn', href: 'https://www.linkedin.com/company/zuzu-club/', handle: 'zuzu-club' },
  { key: 'youtube', name: 'YouTube', href: 'https://www.youtube.com/@TheZuzuClub', handle: '@TheZuzuClub' },
] as const;
export type SocialKey = typeof SOCIAL_LINKS[number]['key'];
